export function DonateButtonNavbar({ settings }) {
  return (
    <li>
      <a href={settings.href}>
        <button
          className="button"
          id="show-reg-modal-btn"
        >
          {settings.text}
        </button>
      </a>
    </li>
  );
}
